module.exports = __webpack_public_path__ + "img/wave.c960180d.svg";